import { ActivatedRouteSnapshot } from "@angular/router";
import { ItineraryService } from "./itinerary.service";
import { Itinerary } from "./itineray.model";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { first } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class ItineraryResolverService implements Resolve<Itinerary> {
  constructor(private itineraryService: ItineraryService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<Itinerary> {
    const itineraryId: string = route.params["itineraryId"];
    return this.itineraryService.get(itineraryId).pipe(first());
  }
}
